import logo_rigilog from '../../../assets/logos/logo_rigilog.svg'
import portal_default from '../../../assets/img/portal_default.jpg'
import portal_piqo from '../../../assets/img/_portal_PIQO-Shop.jpg'
import logo_piqo from '../../../assets/logos/piqoShop_logo_white.png'
import logo_workPerformance from '../../../assets/logos/logo_workPerformance.png'
import logo_voestalpine from '../../../assets/logos/logo_voestalpine.png'
import portal_workPerformace from '../../../assets/img/portal_workPerformance.jpg'
import phone from '../../../assets/icons/phone.svg'
import mail from '../../../assets/icons/mail.svg'
import contact from '../../../assets/icons/paper.svg'

const defaultTheme = {
  ids: [],
  enableCostCenterProductsComparison: true,
  primaryColor: '#E63121',
  logo: logo_rigilog,
  userLogin: {
    type: 'e-mail',
    usernamePlaceholder: 'Benutzer@Beispiel.de',
    usernamePlaceholder_en: 'user@example.com',
    usernameLabel: 'E-Mail Adresse',
    usernameLabel_en: 'Email address',
    usernameLabel_fr: 'Adresse e-mail',
    passwordLabel: 'Passwort',
    passwordLabel_en: 'Password',
    passwordLabel_fr: 'Mot de passe',
    passwordPlaceholder: 'Passwort eingeben',
    passwordPlaceholder_en: 'Enter password',
    passwordPlaceholder_fr: 'Entrer le mot de passe',
    loginBoxHeadline: 'Einloggen',
    loginBoxHeadline_en: 'Log in',
    loginBoxHeadline_fr: 'Connexion',
    // loginBoxText: null,
    // loginBoxText_en: null,
    // loginBoxText_fr: null,
    logoMaxWidth: null,
    logoPadding: null,
    backgroundImage: portal_default,
    phoneIcon: phone,
    mailIcon: mail,
    contactIcon: contact,
    backgroundSize: 'cover',
    loginBoxText: '',
    loginBoxText_en: '',
    loginBoxText_fr: '',
    loginBoxText_es: 'Compra de ropa yc equipamiento para empleados',
    loginBoxText_it: 'Acquista abbigliamento e attrezzature per i dipendenti',
  },
  contactInfos: {
    phoneContact: '+49 (0) 30 / 841 118 07',
    emailContact: 'support@rigilog.com',
    workingWeekHours: 'Mo.-Do. 08:00-17:00 CET',
  },
  footer: {
    backgroundColor: '#177A8D ',
    // borderColor: '#E63121',
    textColor: 'white',
    agbUrl: 'https://rigilog.com/de/geschaeftliches/adv-tom',
    imprintUrl: 'https://rigilog.com/de/impressum',
    dataProtectionUrl: 'https://rigilog.com/de/geschaeftliches/datenschutz',
  },
}

const piqoShop = {
  ...defaultTheme,
  ids: ['09a05332-dfd1-f011-ba80-00155d85ee0e'],
  logo: logo_piqo,
  primaryColor: '#009fe3',
  userLogin: {
    ...defaultTheme.userLogin,
    usernameLabel_de: 'Benutzername',
    usernameLabel_en: 'Username',
    backgroundImage: portal_piqo,
    loginBoxHeadline: 'PIQO PROFI SHOP',
    loginBoxHeadline_en: 'PIQO PROFI SHOP',
    backgroundSize: 'cover',
    loginBoxText: 'Einkaufen mit Köpfchen. Dienstleistung mit IQ',
    loginBoxText_en: 'Smart shopping. Service with IQ.',
  },
  contactInfos: {
    phoneContact: '+49 2602 8385100',
    emailContact: 'shop@piqo.de',
    workingWeekHours: 'Mo.-Fr. 08:00-17:00 CET',
  },
  footer: {
    backgroundColor: 'black',
    borderColor: 'black',
    textColor: 'white',
    footerCopyRight: '© PIQO PROFI SHOP',
  },
  infograph: {
    headline: 'In 3 einfachen Schritten zu Ihrer Bestellung',
    step1: 'Artikel auswählen',
    step2: 'Menge eingeben',
    step3: 'Bestellung abschicken',
  },
}

const workPerformance = {
  ...defaultTheme,
  ids: [''],
  logo: logo_workPerformance,
  primaryColor: '#D4021D',
  userLogin: {
    ...defaultTheme.userLogin,
    usernameLabel_de: 'Benutzername',
    usernameLabel_en: 'Username',
    backgroundImage: portal_workPerformace,
    loginBoxHeadline: 'WORKPERFORMANCE SHOP',
    loginBoxHeadline_en: 'WORKPERFORMANCE SHOP',
    backgroundSize: 'cover',
    loginBoxText: null,
    loginBoxText_en: null,
  },
  contactInfos: {
    phoneContact: '0508011',
    emailContact: 'office@workperformance.at',
    workingWeekHours: 'Mo.-Fr. 08:00-17:00 CET',
  },
  footer: {
    backgroundColor: '#3B3B3B',
    borderColor: '#3B3B3B',
    textColor: 'white',
    footerCopyRight: '© WORKPERFORMANCE SHOP',
  },
}

const voestalpine = {
  ...defaultTheme,
  ids: [''],
  logo: logo_voestalpine,
  primaryColor: '#0F7DAA',
  userLogin: {
    ...defaultTheme.userLogin,
    usernameLabel_de: 'Benutzername',
    usernameLabel_en: 'Username',
    backgroundImage: null,
    backgroundColor: '#0F7DAA',
    loginBoxHeadline: 'VOESTALPINE<br>PROFI SHOP',
    loginBoxHeadline_en: 'VOESTALPINE<br>PROFI SHOP',
    backgroundSize: 'cover',
    loginBoxText: '',
    loginBoxText_en: '',
  },
  contactInfos: {
    phoneContact: '+49 2602 8385100',
    emailContact: 'shop@piqo.de',
    workingWeekHours: 'Mo.-Fr. 08:00-17:00 CET',
  },
  footer: {
    backgroundColor: '#0F7DAA',
    borderColor: '#0F7DAA',
    textColor: 'white',
    footerCopyRight: '© VOESTALPINE SHOP',
  },
}

export const config = {
  default: defaultTheme,
  logix: defaultTheme,
  'piqo-shop': piqoShop,
  workPerformance: workPerformance,
  voestalpine: voestalpine,
}
